// Spec 055 — a poltrona é ANDAR + NÚMERO, não só o número: na Distribusion há operadoras que repetem o
// mesmo número nos dois andares, com classes tarifárias e preços diferentes. O `seatId` ("andar:número")
// vem do mapa de poltronas do Hub e é opaco para o site; o cálculo local só cobre respostas antigas.

/** Chave da poltrona dentro do ônibus. `null` quando não há número (célula sem poltrona). */
export function seatKeyOf(seat) {
	if (!seat) return null
	if (seat.seatId) return seat.seatId

	const number = seat.number || seat.seatNumber || seat.busSeat
	if (!number) return null

	return `${seat.floorNumber || 1}:${number}`
}

/** Duas poltronas são a mesma quando a chave bate (queda para o número em estado antigo). */
export function isSameSeat(seat, key) {
	if (!key) return false

	const seatKey = seatKeyOf(seat)
	if (seatKey && seatKey === key) return true

	// Estado anterior à 055 (sem seatId/andar): a chave chega como número puro.
	const number = seat && (seat.number || seat.seatNumber)
	return !!number && String(number) === String(key)
}

/**
 * Rótulo da poltrona (D7): "01 · Térreo" só quando o ônibus tem mais de um andar — em ônibus de um andar
 * fica "01", como sempre foi. O `floorLabel` só existe quando o mapa veio com andares (o Hub omite
 * `layout.floors` em ônibus de um andar), então a presença dele já é a regra.
 */
export function seatLabel(number, floorLabel) {
	return floorLabel ? `${number} · ${floorLabel}` : `${number}`
}

/** Id de DOM estável por poltrona ("1:01" → "seat-1-01"); o número puro colide entre andares. */
export function seatDomId(seat) {
	const key = seatKeyOf(seat)
	return key ? `seat-${String(key).replace(/[^a-zA-Z0-9_-]/g, '-')}` : undefined
}
